import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ProviderUserName from "../../components/providerUser/ProviderUserDetail/ProviderUserName.tsx";
import {useLocationFormState} from "../../components/providerUser/ProviderUserForm/ProviderUserUpdateForm";
import ProviderUserUpdateFormProvider from "../../components/providerUser/ProviderUserForm/ProviderUserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProviderUserUpdateEditPage = () => {
    
    useTitle(t`Update Provider User`);

    const { providerUserId: id } = useParams();
    
    return (
        <Box data-testid="ProviderUser-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ProviderUser-update-title"
                    >
                        <Trans>Edit Provider User</Trans>:  <ProviderUserName id={id}/>
                    </Typography>
                    <ProviderUserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ProviderUserUpdateEditPage;
